export default __webpack_public_path__ + "static/media/tick_grey.3fddb533.svg";